var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import Table from '../../../components/Table';
import history from 'helpers/History';
import { T } from '../../../helpers/i18n';
var AfiliatesTable = /** @class */ (function (_super) {
    __extends(AfiliatesTable, _super);
    function AfiliatesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCreate = function () {
            history.push('/afiliates/create');
        };
        _this.handleSelectItem = function (value) {
            history.push("/afiliates/".concat(value.id));
        };
        return _this;
    }
    AfiliatesTable.prototype.render = function () {
        var data = this.props.afiliates;
        var datos = data.map(function (value) {
            if (value.calcImport)
                return __assign(__assign({}, value), { calcImport: T('yes') });
            else
                return __assign(__assign({}, value), { calcImport: T('no') });
        });
        var headers = ['name', 'email' /*, 'commission', 'typeCommission', 'calcImport'*/, 'disabled_at'];
        var filters = [
            {
                name: 'actives',
                filter: function (item) { return item.disabled_at === null; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            },
            {
                name: 'all',
                filter: function (item) { return true; }
            }
        ];
        return (React.createElement(Table, { items: datos, header: headers, filters: filters, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); } }));
    };
    AfiliatesTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.afiliateStore.read().then(function (afiliates) { return ({ afiliates: afiliates }); })
            ];
        }),
        observer
    ], AfiliatesTable);
    return AfiliatesTable;
}(Component));
export default AfiliatesTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Afiliates/containers/AfiliatesTable.tsx
// module id = 1586
// module chunks = 0